import React from 'react';
// import { UilFacebookF } from '@iconscout/react-unicons'
// import { UilTwitter } from '@iconscout/react-unicons'
// import { UilInstagramAlt } from '@iconscout/react-unicons'
// import { UilLinkedin } from '@iconscout/react-unicons'

import './Footer.css'


const Footer = () => {
    const date = new Date()
    let currentDate = date.getFullYear();

    return (
        <div id="footer" className="container">
            <div className="row justify-content-md-center  mb-5">


                {/* <div className="col-md-4 col-sm-12 col-lg-4 mt-5">
                    <a className='footerLink' href="#about">About Us</a><br />
                    <a className='footerLink' href="#service">Services</a><br />
                    <a className='footerLink' href="#contact">Contact Us</a>
                </div> */}
                <div className=" col-md-4 col-sm-12 col-lg-4 mt-5">

                    <p className='copyright'> © Copright {currentDate} Limit Design LTD.All Right Reserved.</p>
                </div>
                {/* <div className="col-md-4 col-sm-12 col-lg-4 socials">
                    <br /><br />
                    <UilFacebookF className="footerIcon"></UilFacebookF>
                    <UilInstagramAlt className="footerIcon"></UilInstagramAlt>
                    <UilLinkedin className="footerIcon"></UilLinkedin>
                    <UilTwitter className="footerIcon"></UilTwitter>
                </div> */}
            </div>
        </div >
    );
};

export default Footer;